import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleSound } from "../store/entities/player-settings-slice";
import musicPlayer from "../services/audio/music-player";
import soundFxPlayer from "../services/audio/soundfx-player";

export default function SoundSwitch({ className }) {
  const playerSettings = useSelector((s) => s.playerSettings);
  const dispatch = useDispatch();

  const { show: showJackpotModal } = useSelector((state) => state.jackpotModal);
  const { show: bounsRoundsModal } = useSelector((s) => s.bounsRoundsModal);

  const soundOn = "img/controls/sound-on-icon.svg";
  const soundOff = "img/controls/sound-off-icon.svg";

  const handleSoundToggle = useCallback(() => {
    dispatch(toggleSound());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const debounceSoundToggle = () => {
    handleSoundToggle();
    soundFxPlayer.play("btnClick");
  };

  // LOGIC FOR PLAYING MODAL SOUNDS
  useEffect(() => {
    if (showJackpotModal) {
      if (playerSettings.music_enabled) {
        soundFxPlayer.stop("jackpotWin");
        soundFxPlayer.stop("bonusRounds");
        musicPlayer.stop("rr_trafficambience_loop");
      }
      soundFxPlayer.loop("jackpotWin", true);
      soundFxPlayer.play("jackpotWin");
    } else if (!showJackpotModal && bounsRoundsModal) {
      if (playerSettings.music_enabled) {
        soundFxPlayer.stop("jackpotWin");
        musicPlayer.stop("rr_trafficambience_loop");
      }
      //soundFxPlayer.loop("bonusRounds", true);
      soundFxPlayer.play("bonusRounds");
    } else {
      soundFxPlayer.stop("bonusRounds");
      soundFxPlayer.stop("jackpotWin");
      if (playerSettings.music_enabled) {
        musicPlayer.loop("rr_trafficambience_loop", true);
        musicPlayer.play("rr_trafficambience_loop");
      }
    }
  }, [showJackpotModal, playerSettings.music_enabled, bounsRoundsModal]);

  return useMemo(
    () => {
      return (
        <button
          onClick={() => debounceSoundToggle()}
          style={{ cursor: "pointer" }}
          className={className + " button-icon"}
        >
          <img
            width={24}
            height={24}
            src={playerSettings.sound_enabled ? soundOn : soundOff}
            alt={
              playerSettings.sound_enabled ? "sound-on-icon" : "sound-off-icon"
            }
          />
        </button>
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [className, handleSoundToggle, playerSettings.sound_enabled]
  );
}
